import React from "react";
import EmailVerification from "./EmailVerification";
import EmailVerificationIllustration from "./EmailVerificationIllustration";

const EmailVerificationPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row">
      <div className="w-full lg:w-1/2 flex items-center justify-center px-6 sm:px-12 py-12 lg:py-0" id="email-verification-page-container">
        <EmailVerification />
      </div>

      <div className="hidden lg:flex lg:w-1/2 bg-[#E8F0FF] items-center justify-center" id="email-verification-page-illustration-container">
        <EmailVerificationIllustration />
      </div>
    </div>
  );
};

export default EmailVerificationPage;

